import React from 'react';
import eventImg1 from '../../../images/webp/event-1.webp';
import eventImg2 from '../../../images/webp/event-2.webp';
import eventImg3 from '../../../images/webp/event-3.webp';
import eventImg4 from '../../../images/webp/event-4.webp';
import eventImg5 from '../../../images/webp/event-5.webp';
import eventImg6 from '../../../images/webp/event-6.webp';
import eventImg7 from '../../../images/webp/event-7.webp';
import eventImg8 from '../../../images/webp/event-8.webp';
import eventImg9 from '../../../images/webp/event-9.webp';
import eventImg10 from '../../../images/webp/event-10.webp';
import eventImg11 from '../../../images/webp/event-11.webp';
import eventImg12 from '../../../images/webp/event-12.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faPeopleLine, faTag } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';

const EventDetails = () => {
    return (
        <div>
            <div className="mt-5 mb-5">
                <h1 data-aos="fade-up" data-aos-duration="1000"className="fw-bolder" style={{color: '#ff3465' }}>Bachelorette party</h1>
                <p data-aos="fade-up" data-aos-duration="2000">Morbi accumsan cras feugiat euismod suspendisse purus. Laoreet mi leo id pretium.</p>
                <div data-aos="fade-up" data-aos-duration="3000" className="row" style={{ margin: '30px 0', borderBottom: '3px solid #ff346331' }}>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-6">
                                <p><span style={{ color: '#ff3465', padding: '5px 10px', borderRadius: '50%', background: '#ff346331' }}><FontAwesomeIcon icon={faLocationDot} /></span> California</p>
                            </div>
                            <div className="col-6">
                                <p><span style={{ color: '#ff3465', padding: '5px 10px', borderRadius: '50%', background: '#ff346331' }}><FontAwesomeIcon icon={faPeopleLine} /></span> 50 people</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-6">
                                <p><span style={{ color: '#ff3465', padding: '5px 10px', borderRadius: '50%', background: '#ff346331' }}><FontAwesomeIcon icon={faTag} /></span> $10,000</p>
                            </div>
                            <div className="col-6">
                                <p><span style={{ color: '#ff3465', padding: '5px 10px', borderRadius: '50%', background: '#ff346331' }}><FontAwesomeIcon icon={faClock} /></span> October 15, 2023</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-center row">
                    <div data-aos="fade-up" data-aos-duration="500" className="col-lg-3 col-6">
                        <div className="img-wrapper m-2">
                            <img className="inner-img w-100" src={eventImg5} alt="" />
                        </div>
                    </div>

                    <div data-aos="fade-up" data-aos-duration="1500" className=" col-lg-3 col-6">
                        <div className="img-wrapper m-2">
                            <img className="inner-img w-100" src={eventImg2} alt="" />
                        </div>
                    </div>

                    <div data-aos="fade-up" data-aos-duration="2500" className="col-lg-3 col-6">
                        <div className="img-wrapper m-2">
                            <img className="inner-img w-100" src={eventImg6} alt="" />
                        </div>
                    </div>

                    <div data-aos="fade-up" data-aos-duration="3000" className=" col-lg-3 col-6">
                        <div className="img-wrapper m-2">
                            <img className="inner-img w-100" src={eventImg4} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-5 mb-5">
                <div className="text-end">
                    <h1 data-aos="fade-down" data-aos-duration="1000" className="fw-bolder" style={{color: '#ff3465' }}>Julia's eighteenth birthday</h1>
                    <p data-aos="fade-down" data-aos-duration="2000">Morbi accumsan cras feugiat euismod suspendisse purus. Laoreet mi leo id pretium.</p>
                </div>
                <div data-aos="fade-down" data-aos-duration="3000" className="row" style={{ margin: '30px 0', borderBottom: '3px solid #ff346331' }}>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-6">
                                <p><span style={{ color: '#ff3465', padding: '5px 10px', borderRadius: '50%', background: '#ff346331' }}><FontAwesomeIcon icon={faLocationDot} /></span> California</p>
                            </div>
                            <div className="col-6">
                                <p><span style={{ color: '#ff3465', padding: '5px 10px', borderRadius: '50%', background: '#ff346331' }}><FontAwesomeIcon icon={faPeopleLine} /></span> 50 people</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-6">
                                <p><span style={{ color: '#ff3465', padding: '5px 10px', borderRadius: '50%', background: '#ff346331' }}><FontAwesomeIcon icon={faTag} /></span> $10,000</p>
                            </div>
                            <div className="col-6">
                                <p><span style={{ color: '#ff3465', padding: '5px 10px', borderRadius: '50%', background: '#ff346331' }}><FontAwesomeIcon icon={faClock} /></span> October 15, 2023</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-center row">
                    <div data-aos="fade-down" data-aos-duration="500" className="col-lg-3 col-6">
                        <div className="img-wrapper m-2">
                            <img className="inner-img w-100" src={eventImg7} alt="" />
                        </div>
                    </div>

                    <div data-aos="fade-down" data-aos-duration="1500" className=" col-lg-3 col-6">
                        <div className="img-wrapper m-2">
                            <img className="inner-img w-100" src={eventImg1} alt="" />
                        </div>
                    </div>

                    <div data-aos="fade-down" data-aos-duration="2500" className="col-lg-3 col-6">
                        <div className="img-wrapper m-2">
                            <img className="inner-img w-100" src={eventImg8} alt="" />
                        </div>
                    </div>

                    <div data-aos="fade-down" data-aos-duration="3000" className=" col-lg-3 col-6">
                        <div className="img-wrapper m-2">
                            <img className="inner-img w-100" src={eventImg3} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-5 mb-5">
                <h1 data-aos="fade-up" data-aos-duration="1000" className="fw-bolder" style={{color: '#ff3465' }}>Party on New Year's Eve</h1>
                <p data-aos="fade-up" data-aos-duration="2000">Morbi accumsan cras feugiat euismod suspendisse purus. Laoreet mi leo id pretium.</p>
                <div data-aos="fade-up" data-aos-duration="3000" className="row" style={{ margin: '30px 0', borderBottom: '3px solid #ff346331' }}>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-6">
                                <p><span style={{ color: '#ff3465', padding: '5px 10px', borderRadius: '50%', background: '#ff346331' }}><FontAwesomeIcon icon={faLocationDot} /></span> California</p>
                            </div>
                            <div className="col-6">
                                <p><span style={{ color: '#ff3465', padding: '5px 10px', borderRadius: '50%', background: '#ff346331' }}><FontAwesomeIcon icon={faPeopleLine} /></span> 50 people</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-6">
                                <p><span style={{ color: '#ff3465', padding: '5px 10px', borderRadius: '50%', background: '#ff346331' }}><FontAwesomeIcon icon={faTag} /></span> $10,000</p>
                            </div>
                            <div className="col-6">
                                <p><span style={{ color: '#ff3465', padding: '5px 10px', borderRadius: '50%', background: '#ff346331' }}><FontAwesomeIcon icon={faClock} /></span> October 15, 2023</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-center row">
                    <div data-aos="fade-up" data-aos-duration="500" className="col-lg-3 col-6">
                        <div className="img-wrapper m-2">
                            <img className="inner-img w-100" src={eventImg9} alt="" />
                        </div>
                    </div>

                    <div data-aos="fade-up" data-aos-duration="1500" className=" col-lg-3 col-6">
                        <div className="img-wrapper m-2">
                            <img className="inner-img w-100" src={eventImg10} alt="" />
                        </div>
                    </div>

                    <div data-aos="fade-up" data-aos-duration="2500" className="col-lg-3 col-6">
                        <div className="img-wrapper m-2">
                            <img className="inner-img w-100" src={eventImg11} alt="" />
                        </div>
                    </div>

                    <div data-aos="fade-up" data-aos-duration="3000" className=" col-lg-3 col-6">
                        <div className="img-wrapper m-2">
                            <img className="inner-img w-100" src={eventImg12} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventDetails;